/**
 * Whether an inventory element has geometry usable on the map.
 * Accepts API `has_coordinates`, raw `coordinates`, or legacy string geom.
 */
export function coordsPresent(raw: unknown): boolean {
  if (raw === true) return true
  if (raw === false) return false
  if (raw == null) return false
  if (Array.isArray(raw)) return raw.length > 0
  if (typeof raw === 'string') return raw.trim().length > 0
  return true
}
